export default __webpack_public_path__ + "static/media/Facilities-CACS-4.3f5d99de.jpg";